package com.solevo.dist.utils.di

import org.koin.core.qualifier.Qualifier
import org.koin.core.qualifier.QualifierValue

object UserFirebaseQualifier: Qualifier {
    override val value: QualifierValue = "UserFirebaseRemoteSource"
}

object UserHttpQualifier: Qualifier {
    override val value: QualifierValue = "UserHttpRemoteSource"
}

object QuoteHttpQualifier: Qualifier {
    override val value: QualifierValue = "QuoteHttpRemoteSource"
}

object QuoteFirebaseQualifier: Qualifier {
    override val value: QualifierValue = "QuoteFirebaseRemoteSource"
}

object IODispatcher: Qualifier {
    override val value: QualifierValue = "IODispatcher"
}

object DefaultDispatcher: Qualifier {
    override val value: QualifierValue = "DefaultDispatcher"
}

object BaseUrl: Qualifier {
    override val value: QualifierValue = "baseUrl"
}

object AuthDeeplinkUrl: Qualifier {
    override val value: QualifierValue = "authDeeplinkUrl"
}

object PhotoEvidenceContainerExtension: Qualifier {
    override val value: QualifierValue = "photoEvidenceContainerExtension"
}

object LoyaltyReceiptContainerExtension: Qualifier {
    override val value: QualifierValue = "loyaltyReceiptContainerExtension"
}

object PhotoEvidenceStorageServiceQualifier: Qualifier {
    override val value: QualifierValue = "photoEvidenceStorageServiceQualifier"
}

object TransactionReceiptStorageServiceQualifier: Qualifier {
    override val value: QualifierValue = "transactionReceiptStorageServiceQualifier"
}
